import { PageHeader, Stage } from "components/layout";
import { MyGoalsContent } from "components/marketing-goals/my-goals-content";
import React from "react";
import { Redirect, useLocation } from "react-router";
import { useFeature } from "store/selectors/hooks";
import { AgendaTab } from "./agenda-tab";
import { resolveMyAgendaTab } from "./my-agenda-tabs";

export const MarketingPlanPage: React.FC<unknown> = () => {
    const marketingPlaybookEnabled = useFeature("marketingPlaybook");
    const marketingGoalsEnabled = useFeature("marketingGoals");
    const location = useLocation();

    const features = {
        playbookEnabled: marketingPlaybookEnabled,
        goalsEnabled: marketingGoalsEnabled,
    };
    const activeTab = resolveMyAgendaTab(location.pathname, features);

    if (!activeTab) {
        return <Redirect to="/tasks" />;
    }

    return (
        <Stage>
            <PageHeader title="My Agenda" />
            <div className="min-h-full bg-gray-50">
                <div className="max-w-3xl space-y-4 px-4 py-4 lg:px-6">
                    {activeTab === "goals" ? <MyGoalsContent /> : <AgendaTab />}
                </div>
            </div>
        </Stage>
    );
};
